import { render, staticRenderFns } from "./storage.vue?vue&type=template&id=c5dfd660&scoped=true&"
import script from "./storage.vue?vue&type=script&lang=js&"
export * from "./storage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5dfd660",
  null
  
)

export default component.exports